import { useEffect } from 'react'

function Subscription() {
  useEffect(() => {
    window.location.href = '/subscription.html'
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <p className="text-gray-600 dark:text-gray-400">正在跳转到订阅服务协议...</p>
    </div>
  )
}

export default Subscription
